import { AssetResponseAssetType } from 'generatedTypes/asset/models';
import { useState } from 'react';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import AssetToggle from 'components/AssetToggle';
import Panel from 'components/containers/Panel';
import CreateBatteryForm from 'components/forms/CreateBatteryForm';
import CreateDroneForm from 'components/forms/CreateDroneForm';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CreateAssetForm: FunctionComponent<Props> = ({
    defaultAssetType,
    onCancelClose,
    onClose,
    onCreated,
    requestingClose,
    testId = TEST_ID
}) => {
    const [selectedAssetType, setSelectedAssetType] = useState<AssetResponseAssetType>(
        defaultAssetType ?? AssetResponseAssetType.BATTERY
    );

    return (
        <VerticalContainer className={styles.createAssetForm} testId={testId}>
            <Panel>
                <AssetToggle assetType={selectedAssetType} onChange={setSelectedAssetType} />
            </Panel>

            {selectedAssetType === AssetResponseAssetType.DRONE ? (
                <CreateDroneForm
                    onCancelClose={onCancelClose}
                    onClose={onClose}
                    onCreated={onCreated}
                    requestingClose={requestingClose}
                />
            ) : (
                <CreateBatteryForm
                    onCancelClose={onCancelClose}
                    onClose={onClose}
                    onCreated={onCreated}
                    requestingClose={requestingClose}
                />
            )}
        </VerticalContainer>
    );
};

export default CreateAssetForm;
